import { render, staticRenderFns } from "./CourseSlide.vue?vue&type=template&id=423f5c3e&"
import script from "./CourseSlide.vue?vue&type=script&lang=js&"
export * from "./CourseSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports